import api from "../../../helpers/api";

// export const getPendingArtisans = (body) =>
//   api.post("moderation-pool/get-pending-artisans", { ...body });
  
export const getPendingArtisans = (body) =>
  api.post("artisan-staging/search-artisans", { ...body });
// export const updatePendingArtisan = (body) =>
//   api.post("moderation-pool/moderate-artisans", { ...body });


export const updatePendingArtisan = (body) =>
  api.post("artisan-staging/moderate-create-artisan", { ...body });


export const getSinglePendingArtisan = (id) => api.get(`/artisan-staging/${id}`)


export const deleteSinglePendingArtisan = (id) => api.delete(`/artisan-staging/${id}`)


export const moderateSinglePendingArtisan = (id) => api.post(`artisan-staging/moderate-create-artisan`, id);
export const moderateUpdateSinglePendingArtisan = (id) => api.post(`artisan-staging/moderate-update-artisan`, id);